import React, { memo, useCallback, useState } from "react";
import { Modal } from "react-bootstrap";
import { ToastContainer } from 'react-toastify';
import DataTableOffer from "./DataTableOffer";

const ModalSelectOffer = ({ onCallback, show, close }) => {

    const [userLogin] = useState(
        JSON.parse(localStorage.getItem('knowLogin')) || []
    );

    const [accesToken] = useState(
        JSON.parse(localStorage.getItem('credentials')) || []
    );

    const onSelectedCallback = useCallback((e) => {
        onCallback(e);
        close();
    }, []);


    return (
        <>
            <ToastContainer position="top-end" className="p-3"></ToastContainer>
            <Modal size="lg" fullscreen show={show} onHide={close} backdrop="static" keyboard={false}>
                {/* fullscreen */}
                <Modal.Header closeButton>
                    <Modal.Title>Pilih Penawaran</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-0">
                    <DataTableOffer onCallback={(e) => onSelectedCallback(e)} />
                </Modal.Body>
            </Modal>
        </>
    );
}

export default memo(ModalSelectOffer);
